import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import styles from './InaccuracyReportDialog.scss';
import { setPopUp } from 'actions/environment';
import cn from 'classnames';
import { createInaccuracyReport } from 'actions/building';
import tracker from '../../../services/tracker';
import { createSelector } from 'reselect';
import { gaEvent, trackGA } from 'services/ga';
import debounce from 'lodash.debounce';

class InaccuracyReportDialog extends Component {

  constructor(props) {
    super(props);
    this.initialState = {
      inaccuracyReportText: '',
      reportSendedSuccess: false
    };
    this.state = this.initialState;
    this.debouncedTrackGA = debounce(this.trackGAEvent, 3000);
  }

  componentWillUnmount() {
    const { profile, objectType, building } = this.props;

    if (!this.state.reportSendedSuccess) {
      trackGA(gaEvent.buildingInaccuracyReportButtonsClick({
        eventLabel: 'zakryt',
        eventContent: building.title,
        productType: objectType,
        productName: building.title,
        productID: building.id,
        user_id: profile.id
      }));
    }
  }

  trackGAEvent = () => {
    const { profile, objectType, building } = this.props;
    const { inaccuracyReportText } = this.state;

    if (inaccuracyReportText.length >= 2) {
      trackGA(gaEvent.buildingInaccuracyReportInput({
        eventContent: building.title,
        productType: objectType,
        productName: building.title,
        productID: building.id,
        user_id: profile.id
      }));
    }
  }

  handleTextChange = (event) => {
    const { value } = event.target;
    if (value.length <= 500) {
      this.setState({
        inaccuracyReportText: value
      });
    }
    this.debouncedTrackGA();
  }

  handleCreateReportClick = (e) => {
    e.preventDefault();
    const { building, phone } = this.props;
    const { inaccuracyReportText } = this.state;

    tracker.sendEvent('Web_Card_Report_About_Inaccuracy', { телефон: phone });
    this.handleTrackButtonClickEvent({ buttonName: 'otpravit' });

    if (building && inaccuracyReportText) {
      this.props.createInaccuracyReport({
        id: building.id,
        message: inaccuracyReportText
      }).then(() => {
        this.setState({ reportSendedSuccess: true });
      }).catch((error) => {
        console.error(error);
      });
    }
  }

  handleClosePopup = () => {
    this.props.setPopUp();
  }

  handleTrackButtonClickEvent = ({ buttonName }) => {
    const { profile, objectType, building } = this.props;

    trackGA(gaEvent.buildingInaccuracyReportButtonsClick({
      eventLabel: buttonName,
      eventContent: building.title,
      productType: objectType,
      productName: building.title,
      productID: building.id,
      user_id: profile.id
    }));
  }

  render() {
    const { t } = this.props;
    const { inaccuracyReportText, reportSendedSuccess } = this.state;
    const textLength = inaccuracyReportText.length;

    return (
      <div>
        <div className={styles.PopupContent}>
          {reportSendedSuccess
            ?
              <div className={styles.DoneWrap}>
                <div className={styles.DoneTitle}>
                  {t('components.building.main.inaccuracyReportDialog.reportSended')}
                </div>
                <button
                  className={cn(styles.ActionBtn, styles.InaccuracyReportButton, 'button-primary', 'button-primary--md')}
                  onClick={() => {
                    this.handleClosePopup();
                  }}
                >
                  {t('components.building.main.inaccuracyReportDialog.done')}
                </button>
              </div>
            :
              <div>
                <div className={styles.PopupTitle}>
                  {t('components.building.main.inaccuracyReportDialog.title')}
                </div>
                <div className={styles.Divider} />
                <div className={styles.PopupSubtitle}>
                  {t('components.building.main.inaccuracyReportDialog.subtitle')}
                </div>
                <form
                  className={cn(styles.InaccuracyReportForm)}
                  onSubmit={this.handleCreateReportClick}
                >
                  <textarea
                    className={cn(styles.InaccuracyReportTextArea)}
                    placeholder={t('components.building.main.inaccuracyReportDialog.textAreaPlaceholder')}
                    onChange={this.handleTextChange}
                    maxLength={500}
                    onInput={(e) => {
                      e.target.style.height = 'auto';
                      e.target.style.height = `${e.target.scrollHeight}px`;
                    }}
                    rows={2}
                  />
                  <div className={cn(styles.ReportHelperText)}>
                    {textLength >= 500 ? t('components.building.main.inaccuracyReportDialog.noCharsLeft') : ''}
                  </div>
                  <button
                    className={cn(styles.ActionBtn, styles.InaccuracyReportButton, 'button-primary', 'button-primary--md')}
                    disabled={textLength < 10}
                  >
                    {t('components.building.main.inaccuracyReportDialog.button')}
                  </button>
                </form>
              </div>
          }
        </div>
      </div>
    );
  }
}

const userSelector = createSelector(
  state => state.profile,
  (profile) => ({
    ...profile
  })
);

export default withTranslation()(connect(
  userSelector,
  {
    setPopUp,
    createInaccuracyReport
  })(InaccuracyReportDialog));



// WEBPACK FOOTER //
// ./src/components/Building/InaccuracyReportDialog/InaccuracyReportDialog.js